class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.summary = this.mainDetailsToggle.querySelector('summary');
    
    // Délai pour éviter la fermeture accidentelle lors du passage rapide de la souris
    this.hoverDelay = 150;
    this.closeDelay = 300;
    this.hoverTimeout = null;
    this.closeTimeout = null;

    // Événements de survol
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    
    // Événements de focus pour l'accessibilité
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    
    // Empêcher le comportement par défaut du clic sur summary
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onMouseEnter() {
    // Annuler le timeout de fermeture s'il existe
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    // Ouvrir avec un léger délai pour éviter l'ouverture accidentelle
    this.hoverTimeout = setTimeout(() => {
      this.open();
    }, this.hoverDelay);
  }

  onMouseLeave() {
    // Annuler le timeout d'ouverture s'il existe
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    // Fermer avec un délai pour permettre à l'utilisateur de revenir
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, this.closeDelay);
  }

  onSummaryClick(event) {
    // Empêcher le comportement par défaut d'ouverture/fermeture au clic
    event.preventDefault();
    
    // Option : vous pouvez garder le toggle au clic si souhaité
    // this.toggle();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }

  toggle() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);